import { gql } from '@urql/core';
import Link from 'next/link';
import React from 'react';
import { Espin_Event, EventCardFragment } from '../../../generated/spin-graphql';
import { EventCard } from '../../events/card/EventCard';

type Props = {
    events: EventCardFragment[];
};

gql`
    fragment UpcomingEventsCard on espin_event {
        ...EventCard
    }
`;

export const UpcomingEventsCard: React.FC<Props> = ({ events }) => {
    return (
        <div className="upcoming-events-card">
            <div className="title-container">
                <h2 className="title">Upcoming Events</h2>
                <Link href={'/events'}>
                    <a className="button blue-button small-button">All Events</a>
                </Link>
            </div>
            <div className="content">
                {events.map((event: Espin_Event, index: number) => (
                    <EventCard key={`upcoming-event-card-${index}`} event={event} />
                ))}
            </div>
        </div>
    );
};
